document.addEventListener('DOMContentLoaded', function () {
  if (window.Shopify && window.Shopify.designMode) {
    const mainContent = document.getElementById('MainContent');
    const sections = document.querySelectorAll('.content-for-layout section');
    const sectionFooter = document.querySelector('div.section-footer');

    sections.forEach(section => {
      section.style.position = 'relative';
    });

    if (sectionFooter) {
      mainContent.appendChild(sectionFooter);
      sectionFooter.style.position = 'relative';
    }
    return;
  }
  window.scrollTo({ top: 0, behavior: 'instant' });
  const footer = document.querySelector('div.section-footer');
  const mainContent = document.getElementById('MainContent');
  const contentForLayout = document.querySelector('.content-for-layout'); // Select content-for-layout

  const cardsRowSection = document.querySelector('.section.content-cards-row');
  const sectionFooterSection = document.querySelector(
    '.section.section-footer footer'
  );
  if (cardsRowSection && sectionFooterSection) {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('content-cards-row');
    while (cardsRowSection.firstChild) {
      wrapperDiv.appendChild(cardsRowSection.firstChild);
    }
    sectionFooterSection.insertBefore(wrapperDiv, sectionFooterSection.firstChild);
    cardsRowSection.remove();
  }

  mainContent.appendChild(footer);

  let currentCard = 0;
  const cards = Array.from(mainContent.children);
  let inTransition = false;
  let cumulativeDelta = 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;

  cards[currentCard].classList.add('active', 'first');

  function isCardFullyVisible(card) {
    const rect = card.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= window.innerHeight;
  }

  function getScrollThreshold() {
    const mobileScrollThreshold = 50;
    const desktopScrollThreshold = window.xerjoffAnimationThreshold || 200;

    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    return isTouchDevice ? mobileScrollThreshold : desktopScrollThreshold;
  }

  function handleScroll(e) {
    //e.preventDefault();

    if (inTransition) return;

    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      return;
    }

    const direction = e.deltaY > 0 ? 'down' : 'up';

    if (
      cumulativeDelta !== 0 &&
      ((cumulativeDelta > 0 && e.deltaY < 0) ||
        (cumulativeDelta < 0 && e.deltaY > 0))
    ) {
      cumulativeDelta = 0;
    }
    cumulativeDelta += e.deltaY;

    if (Math.abs(cumulativeDelta) < getScrollThreshold()) return;

    if (currentCard < cards.length - 1) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    cumulativeDelta = 0;

    let newCardIndex = currentCard;
    if (direction === 'down' && currentCard < cards.length - 1) {
      newCardIndex = currentCard + 1;
      inTransition = true;
      cards[newCardIndex].classList.add('active');
      cards[newCardIndex].style.zIndex =
        parseInt(cards[currentCard].style.zIndex || 1) + 1;
      cards[newCardIndex].addEventListener(
        'transitionend',
        function handler(event) {
          if (event.propertyName === 'transform') {
            currentCard = newCardIndex;
            inTransition = false;
            cards[newCardIndex].removeEventListener('transitionend', handler);

            // Check if it's the last card
            if (currentCard === cards.length - 1) {
              console.log('Last card reached, apply visible');
              console.log(document.documentElement);
              
              document.documentElement.style.overflow = 'visible'; // Remove overflow hidden
              if (contentForLayout) {
                contentForLayout.style.zIndex = '3'; // Apply z-index to content-for-layout
              }
            }
          }
        }
      );
    } else if (direction === 'up' && currentCard > 0) {
      if (!isCardFullyVisible(cards[currentCard])) return; // Ensure the card's upper part is fully visible

      inTransition = true;
      cards[currentCard].classList.remove('active');
      cards[currentCard].addEventListener(
        'transitionend',
        function handler(event) {
          if (event.propertyName === 'transform') {
            currentCard = currentCard - 1;
            inTransition = false;
            cards[currentCard + 1].removeEventListener(
              'transitionend',
              handler
            );

            // Reset styles if moving away from the last card
            if (currentCard < cards.length - 1) {
              console.log('apply hidden again');

              document.documentElement.style.overflow = 'hidden'; // Reapply overflow hidden
              if (contentForLayout) {
                contentForLayout.style.zIndex = ''; // Reset z-index
              }
            }
          }
        }
      );
    }
  }

  function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchEndX = touchStartX;
    touchEndY = touchStartY;
  }

  function handleTouchMove(e) {
    touchEndX = e.touches[0].clientX;
    touchEndY = e.touches[0].clientY;
  }

  function handleTouchEnd() {
    if (inTransition) return;

    const deltaX = Math.abs(touchEndX - touchStartX);
    const deltaY = Math.abs(touchEndY - touchStartY);

    if (deltaX > deltaY || deltaY < 175) {
      return;
    }
    if (deltaY < getScrollThreshold()) return;

    const direction = touchStartY - touchEndY > 0 ? 'down' : 'up';

    let newCardIndex = currentCard;
    if (direction === 'down' && currentCard < cards.length - 1) {
      newCardIndex = currentCard + 1;
      inTransition = true;
      cards[newCardIndex].classList.add('active');
      cards[newCardIndex].style.zIndex =
        parseInt(cards[currentCard].style.zIndex || 1) + 1;
      cards[newCardIndex].addEventListener(
        'transitionend',
        function handler(event) {
          if (event.propertyName === 'transform') {
            currentCard = newCardIndex;
            inTransition = false;
            cards[newCardIndex].removeEventListener('transitionend', handler);

            // Check if it's the last card
            if (currentCard === cards.length - 1) {
              console.log('Last card reached');
              
              document.documentElement.style.overflow = 'visible'; // Remove overflow hidden
              if (contentForLayout) {
                contentForLayout.style.zIndex = '3'; // Apply z-index to content-for-layout
              }
            }
          }
        }
      );
    } else if (direction === 'up' && currentCard > 0) {
      if (!isCardFullyVisible(cards[currentCard])) return; // Ensure the card's upper part is fully visible

      inTransition = true;
      cards[currentCard].classList.remove('active');
      cards[currentCard].addEventListener(
        'transitionend',
        function handler(event) {
          if (event.propertyName === 'transform') {
            currentCard = currentCard - 1;
            inTransition = false;
            cards[currentCard + 1].removeEventListener(
              'transitionend',
              handler
            );

            // Reset styles if moving away from the last card
            if (currentCard < cards.length - 1) {
              console.log('apply hidden again');

              document.documentElement.style.overflow = 'hidden'; // Reapply overflow hidden
              if (contentForLayout) {
                contentForLayout.style.zIndex = ''; // Reset z-index
              }
            }
          }
        }
      );
    }
  }

  document.addEventListener('wheel', handleScroll, { passive: false });
  document.addEventListener('touchstart', handleTouchStart, { passive: true });
  document.addEventListener('touchmove', handleTouchMove, { passive: true });
  document.addEventListener('touchend', handleTouchEnd, { passive: true });
  
  if (window.location.search.includes('customer_posted')) {
    window.addEventListener('wheel', function(e) {
      console.log('scrolling to top');
      
      if (e.deltaY < 150) { 
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, { passive: false });
  }
});